<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
    @hidden="onModalHidden"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col md="4">
          <b-input
            maxlength="31"
            v-on:keyup.enter="onScan()"
            @keydown="handleKeyDown"
            autofocus
            type="text"
            ref="cdBarra"
            v-model="cd_barra"
            @contextmenu="handleWritingBarcodePermission($event)"
            @dragover="handleWritingBarcodePermission($event)"
            @paste="handleWritingBarcodePermission($event)"
            @drop="handleWritingBarcodePermission($event)"
          ></b-input>
          <span>Qtde. caracteres código de barra: {{ qtdCaracteres }}</span>
        </b-col>
        <b-col class="px-1 mb-1">
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
            >Escanear código</b-btn
          >
        </b-col>
        <b-col 
          class="p-0" 
          v-if="getPermissionFw('expedicao.cancela.bip.volumes')">      
            <b-btn
              :disabled="loading"
              @click="cancelBipExpedicao()"
              style="
                background-color: #dc3545 !important;
                border: #dc3545 1px solid;
              "
              >Cancelar Bipagem</b-btn
            >
        </b-col>
        <b-col md="2" class="px-1 mb-1">
          <b-input disabled type="text" v-model="qtde_nfs"></b-input>
          <span class="px-1 mb-1">Qtde. NFs Bipadas</span>
        </b-col>
        <b-col md="2" class="px-1 mb-1">
          <currency-input
            class="form-control"
            v-model="peso_bruto_total"
            placeholder="Peso total bruto"
            disabled
            :auto-decimal-mode="true"
            :currency="{ prefix: ' ' }"
            :distraction-free="getCurrency"
          />
          <span>Peso Bruto</span>
        </b-col>
      </b-row>
    </form>
    <b-row>
      <b-col md="4" style="display: flex; align-items: center">
        <span>Qtde. volumes bipados / Total de volumes : </span>
        <h4 class="ml-1">
          {{ this.qtd_volumes_bipados_total }}/{{ this.qtd_volumes_total }}
        </h4>
      </b-col>
    </b-row>
    <div class="horizontal-scroll">
      <div class="loadingDataPosition">
        <div class="loadingData" v-if="loading"></div>
        <vuetable
          ref="vuetable"
          :api-mode="false"
          :data="notas_fiscais"
          :fields="fields"
          :row-class="onRowClass"
          :css="css"
          :append-params="moreParams"
          track-by="docfis_id"
          pagination-path=""
          @vuetable:load-error="onError"
          @vuetable:pagination-data="onPaginationData"
          @vuetable:loaded="onLoaded"
          detail-row-component="expedicaocargaform-detalhes"
          @vuetable:cell-clicked="onDetail"
        >
          <template slot="actions" slot-scope="props">
            <div class="custom-actions">
              <a
                @click="onDetail(props.rowData, null, null)"
                v-b-tooltip
                title="Ver detalhes"
                ><i class="fa fa-plus"></i
              ></a>
            </div>
          </template>
          <template slot="exige_conferencia_exp" slot-scope="props">
            <span
              class="badge badge-danger"
              v-if="props.rowData.exige_conferencia_exp.valor == 2"
              >{{ props.rowData.exige_conferencia_exp.descr }}</span
            >
            <span
              class="badge badge-success"
              v-if="props.rowData.exige_conferencia_exp.valor == 1"
              >{{ props.rowData.exige_conferencia_exp.descr }}</span
            >
          </template>
          <template slot="quantidade" slot-scope="props">
            <span
              >{{ props.rowData.qtde_bipada }} /
              {{ props.rowData.qtde_total }}</span
            >
          </template>
          <template slot="regiao_despesa" slot-scope="props">
            <span v-if="props.rowData.regiao_despesa.regiao_despesa != null"
              >{{
                props.rowData.regiao_despesa.regiao_despesa.cd +
                " - " +
                props.rowData.regiao_despesa.regiao_despesa.descr
              }}
            </span>
            <span
              v-if="
                props.rowData.regiao_despesa.doc_rps != null &&
                props.rowData.regiao_despesa.doc_rps.doc_rps_regiao != null
              "
              >{{ props.rowData.regiao_despesa.doc_rps.doc_rps_regiao.texto }}
            </span>
          </template>
        </vuetable>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="verifyOcorrence()" variant="secondary"> Validar </b-btn>
        <b-btn
          @click="ajustaStatusVolume()"
          variant="secondary"
          v-if="getPermissionFw('expedicao.finalizarcargaespecial')"
        >
          Finalizar carga especial
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ExpedicaoCargaFormDetalhes from "./ExpedicaoCargaFormDetalhes.vue";
import WritingBarcodePermission from '../mixins/WritingBarcodePermission';

// Constantes de módulo: carregadas uma única vez, compartilhadas por todas
// as instâncias — evita re-execução do require() a cada montagem.
const AUDIO_SUCESSO = require("../../public/audio/sucesso.mp3");
const AUDIO_ERRO = require("../../public/audio/erro.mp3");

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoCargaFormDetalhes,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  mixins: [WritingBarcodePermission],
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      qtd_volumes_total: 0,
      qtd_volumes_bipados_total: 0,
      permite_digitar: false,
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      ultimaTeclaPressionada: 0,
      isFullscreen: false,
      // Audio instanciado lazily em tocaMusica() para evitar
      // alocação de buffers de decodificação desnecessária na montagem.
      song: null,
      errors_array: [],
      notas_fiscais: [],
      cd_barra: "",
      qtde_nfs: 0,
      peso_bruto_total: 0,
      nota: {
        cnpj: "",
        razao_social: "",
        num_fiscal: "",
        serie: "",
        num_volume: "",
      },
      docfis: [],
      form: new Form({
        docfis: [],
        partipcar_id: "",
        partpemb_id: "",
        partiprod_id: "",
        carga_id: "",
        cd_barra: "",
        nota: {},
      }),
      form_especial: new Form({
        carga_id: "",
      }),
      helpForm: new Form({ search: "", docfis_id: "", carga_id: "" }),
      fields: [
        {
          name: "num_fiscal",
          title: "N° Fiscal",
        },
        {
          name: "__slot:quantidade",
          title: "Qtde.",
        },
        {
          name: "cnpj",
          title: "CNPJ",
        },
        {
          name: "razao_social",
          title: "Razão Social",
        },
        {
          name: "__slot:regiao_despesa",
          title: "Regiao",
        },
        {
          name: "__slot:exige_conferencia_exp",
          title: "Exige conferência?",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handleGlobalKeydown);
  },
  created() {
    this.setPermissionToCheck('expedicao.digitaretiqueta');
  },
  methods: {
    handleGlobalKeydown(e) {
      if (!this.showModal || this.loading) return;

      const currentTime = new Date().getTime();
      
      if (currentTime - this.lastKeystrokeTime > 50) {
        this.barcodeBuffer = "";
      }
      
      this.lastKeystrokeTime = currentTime;
      
      if (e.key === "Enter") {
        if (this.barcodeBuffer.length > 3) {
          const isInputFocused = document.activeElement && 
                                 (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA');
          
          if (!isInputFocused) {
            e.preventDefault();
            this.cd_barra = this.barcodeBuffer;
            this.onScan();
          }
          this.barcodeBuffer = "";
        }
      } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        this.barcodeBuffer += e.key;
      }
    },
    verifyOcorrence() {
      this.form.get(`/api/expedicao/carga/${this.form.carga_id}/validar`).then((response) => {
        new ReturnApi(response, this);
      }).catch((errors) => {
        new ReturnApi(errors, this, true, null, null, false);
      });
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.docfisttra_id);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    tocaMusica(musica) {
      // Lazy init: cria o HTMLMediaElement apenas na primeira chamada.
      // Reutiliza a mesma instância nas chamadas seguintes para evitar
      // acúmulo de objetos Audio não liberados.
      if (!this.song) {
        this.song = new Audio();
      }
      this.song.pause();
      this.song.currentTime = 0;
      this.song.src = musica;
      this.song.play();
    },
    _destroyAudio() {
      if (this.song) {
        this.song.pause();
        this.song.src = '';
        this.song = null;
      }
    },
    onModalHidden() {
      // Chamado sempre que o modal fecha (v-model false ou clique em fechar).
      // Libera o Audio e reseta o estado para garantir que nenhum
      // buffer de áudio fique preso em memória entre operações.
      this._destroyAudio();
    },
    onCreate(carga_id, tipo) {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = [];
      this.docfis = [];
      this.isDisabled = true;
      this.loading = false;
      this.modal_titulo = "Auditoria de Volume";
      this.modal_botao = "Auditoria de Volume";
      this.modal_acao = "i";
      this.form.reset();
      this.notas_fiscais = [];
      this.cd_barra = "";
      this.qtde_nfs = 0;
      this.qtd_volumes_total = 0;
      this.qtd_volumes_bipados_total = 0;
      this.peso_bruto_total = 0;
      this.form_especial.carga_id = carga_id;
      if (tipo == 2) {
        this.loading = true;
        this.isDisabled = true;
        this.form.carga_id = carga_id;
        this.form
          .post("/api/expedicao/buscacarga")
          .then((response) => {
            new ReturnApi(response, this);
            response.data.forEach((item, i) => {
              this.notas_fiscais.push({
                docfis_id: item.docfis_id,
                exige_conferencia_exp: item.exige_conferencia_exp,
                volumes: item.volumes,
                regiao_despesa: item.regiao_despesa,
                carga_id: item.carga_id,
                num_fiscal: item.num_fiscal,
                qtde_total: item.qtde_total,
                qtde_bipada: item.qtde_bipada,
                cnpj: item.cnpj,
                razao_social: item.razao_social,
                status: item.status,
              });
              // Acumuladores calculados em uma única passagem sem push reativo.
              this.qtd_volumes_total += item.qtde_volume_total;
              this.qtd_volumes_bipados_total += item.qtde_bipada;
              this.peso_bruto_total =
                this.peso_bruto_total + item.peso_bruto_nf;
            });
            this.qtde_nfs = response.resumo.qtde_nfs_bipadas;
            this.peso_bruto_total = response.resumo.peso_bruto_nfs;
            this.checaDisabledBotao();
            this.form.carga_id = response.data[0].carga_id;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({ erro: obj });
                  });
                }
              }
            }
          });
      }
      this.$refs.modal_form.show();
    },
    onScan() {
      if (!this.cd_barra || this.cd_barra.trim() === "") {
        return;
      }
      this.errors_array = [];
      this.form.nota = this.nota;
      this.form.cd_barra = this.cd_barra;
      this.cd_barra = "";
      // this.permite_digitar = false;
      this.form
        .post("/api/expedicao/bip")
        .then((response) => {
          // Trabalha diretamente em this.notas_fiscais sem criar uma const
          // snapshot — evita prender a referência reativa no closure da Promise.
          const nota_index = this.notas_fiscais.findIndex(
            (item) => item.docfis_id == response.data.docfis_id
          );

          if (nota_index > -1) {
            const updated_nota = { ...this.notas_fiscais[nota_index], ...response.data };
            this.$set(this.notas_fiscais, nota_index, updated_nota);
          }

          new ReturnApi(response, this);

          // Repurchase popup
          if (response.data.recompra_avaria_alerta) {
            this.$Simplert.open({
              title: "Atenção",
              message: response.data.recompra_avaria_alerta,
              type: "warning",
              useCloseBtn: true,
              customCloseBtnText: "Fechar",
            });
          }

          this.qtde_nfs = response.resumo.qtde_nfs_bipadas;
          this.peso_bruto_total = response.resumo.peso_bruto_nfs;
          this.cd_barra = "";
          this.$snotify.clear();
          this.$snotify.success("Volume bipado", "Sucesso");
          this.qtd_volumes_bipados_total = response.data.qtde_bipada_scan;
          this.tocaMusica(AUDIO_SUCESSO);
          this.checaDisabledBotao();
        })
        .catch((errors) => {
          this.$snotify.clear();
          new ReturnApi(errors, this, false, null, null, false);
          // this.permite_digitar = true;
          this.tocaMusica(AUDIO_ERRO);
          this.$refs.cdBarra.blur();
          this.cd_barra = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ajustaStatusVolume() {
      this.loading = true;
      this.isDisabled = true;
      this.form_especial
        .post("/api/expedicao/ajustavolume")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    checaDisabledBotao() {
      this.notas_fiscais.forEach((item, i) => {
        if (item.exige_conferencia_exp.valor == 1) {
          //Sim
          if (item.bipada != item.qtde_total) {
            this.isDisabled = true;
          }
        }
      });
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/expedicao/bip/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/montagemcarga/transportadora/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.onFilterReset();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },

    handleKeyDown(event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "c" || event.key === "v")
      ) {
        event.preventDefault();
      }
    },
    onRowClass(data, index) {
      return data.qtde_bipada == data.qtde_total
        ? "table-success"
        : "table-warning";
    },
    cancelBipExpedicao() {
      var vm = this;
      var carga_id = this.form.carga_id;
      const onConfirmUnitWrapper = () => {
        confirmCancelFn(vm, carga_id);
      };

      let confirmCancelFn = function (vm, carga_id) {
        vm.form
          .post("/api/expedicao/cancelBipExpedicao")
          .then((response) => {
            new ReturnApi(response, vm);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };

      let obj = {
        title: "Atenção!",
        message: "Deseja prosseguir com o cancelamento da bipagem?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    checkPermissionBip() {
      return this.getPermissionFw("expedicao.digitaretiqueta"); //
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },

  },
  computed: {
    qtdCaracteres() {
      return this.cd_barra.length;
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
  watch: {
    'cd_barra'(newValue, oldValue) {
      // Evita duplo processamento: quando o handler DOM já limpou o campo
      // (paste, drop, dragover, contextmenu), o newValue chega como ''
      // e não precisa ser revalidado aqui.
      if (!newValue) return;
      this.handleWritingBarcodePermission(newValue, oldValue);
    }
  },
  beforeDestroy() {
    // Última linha de defesa: garante liberação caso o componente seja
    // de fato destruído (ex: troca de rota). O cleanup principal ocorre
    // em onModalHidden() toda vez que o modal fecha.
    this._destroyAudio();
  }
};
</script>
<style>
.horizontal-scroll {
  overflow-y: auto;
}
</style>
